<template>
  <div
    class="ly-c-table-container"
    :class="{
      'table-container': (isTableScroll && isScroll === null) || isScroll,
    }"
  >
    <div class="ly-c-table ly-c-flex column" :class="[tableClass]">
      <!-- :height="getHeight()" height="100%"-->
      <slot name="top"></slot>
      <el-table
        :data="tableData"
        style="width: 100%"
        :height="
          (isTableScroll && isScroll === null) || isScroll ? '100%' : null
        "
        v-loading="loading"
        :row-key="rowKey"
        :row-class-name="tableRowClassName"
        @select="handleSelect"
        @select-all="handleSelectAll"
        @selection-change="handleSelectionChange"
        @expand-change="handleExpandChange"
        @row-click="rowClick"
        @cell-click="cellClick"
        @cell-mouse-enter="cellMouseEnter"
        @cell-mouse-leave="cellMouseLeave"
        ref="tableRef"
        :lazy="lazy"
        :load="load"
        :expand-row-keys="expandRowKeys"
        :tree-props="treeProp"
        :stripe="stripe"
        :header-row-class-name="headerRowClassName"
      >
        <!-- 空数据-->
        <template slot="empty" v-if="emptyFlag">
          <slot name="tableEmpty">
            <div>
              <img :src="noDataImg" />
              <p>暂无数据</p>
            </div>
          </slot>
        </template>
        <!-- 是否显示多选，多选框支持自定义 -->
        <template v-if="selection">
          <slot name="selection">
            <el-table-column
              type="selection"
              width="55"
              :show-overflow-tooltip="false"
            ></el-table-column>
          </slot>
        </template>
        <!-- 是否开启展开行功能-->
        <el-table-column type="expand" v-if="tableExpand">
          <template slot-scope="scope">
            <slot name="col-expand" :row="scope"></slot>
          </template>
        </el-table-column>
        <!---------- 列表内容 Begin ------------>
        <template>
          <slot>
            <template v-for="(item, index) in tableColumns">
              <el-table-column
                :prop="item.prop"
                :label="item.label"
                :align="item.align || 'left'"
                :width="item.width ? item.width : ''"
                :key="item.prop + index"
                :show-overflow-tooltip="
                  item.showTooltip != undefined ? item.showTooltip : showTooltip
                "
                :min-width="item.minWidth ? item.minWidth : ''"
                v-if="!item.isColumnSlot"
                :fixed="item.fixed ? item.fixed : false"
                :sortable="item.sortable"
              >
                <!-- 自定义头部 -->
                <template slot="header">
                  <slot :name="item.prop + 'Header'">
                    <span>{{ item.label }}</span>
                  </slot>
                </template>
                <!-- 列表数据-->
                <template slot-scope="scope">
                  <span
                    v-if="!item.slot && !getNull(scope.row[item.prop] + '')"
                  >
                    <!-- 时间 -->
                    <span v-if="item.type == 'time'">{{
                      dateFormat(scope.row[item.prop], item.timeType)
                    }}</span>
                    <!-- 字典值 -->
                    <span
                      v-else-if="
                        !['time', 'status', 'switch'].includes(item.type) &&
                        item.dicList
                      "
                    >
                      {{ getDicName(scope.row[item.prop], item.dicList) }}</span
                    >
                    <div v-else-if="['status', 'switch'].includes(item.type)">
                      <el-switch
                        v-if="
                          (!item.permission ||
                            btnPermission(item.permission)) &&
                          showStatus(item, scope)
                        "
                        class="status-switch"
                        :class="[
                          {
                            more: item.params && item.params.isMore,
                            'no-status':
                              item.params &&
                              item.params.isMore &&
                              scope.row[item.prop] == 0,
                          },
                          item.className ? item.className : '',
                        ]"
                        :value="scope.row[item.prop]"
                        :active-value="1"
                        :inactive-value="0 || 2"
                        :active-text="
                          getDicName(scope.row[item.prop], item.dicList)
                        "
                        @change="switchChange(scope.row, item.params, item)"
                      >
                        <!-- :width="28" -->
                      </el-switch>
                      <span v-else>{{
                        getDicName(scope.row[item.prop], item.dicList)
                      }}</span>
                    </div>

                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </span>

                  <!-- item.slot判断是否自定义列的显示内容 -->
                  <slot
                    :name="item.slot"
                    :index="scope.$index"
                    :row="scope.row"
                    v-if="item.slot"
                  ></slot>
                </template>
              </el-table-column>
              <slot :name="item.prop + 'Column'" v-if="item.isColumnSlot">
              </slot>
            </template>
          </slot>
        </template>
        <!---------- 列表内容 end ------------>
        <slot name="operateBtn">
          <el-table-column
            v-if="btnList.length > 0 && hasOperation"
            :fixed="operateFixed"
            :width="operateWidth"
            :label="operateLabel"
          >
            <template slot-scope="scope">
              <btn-list
                :num="btnNum"
                v-on="$listeners"
                v-bind="$attrs"
                :btnList="newBtnList"
                :scope="scope"
              ></btn-list>
            </template>
          </el-table-column>
        </slot>
      </el-table>
      <!---------- 分页 Begin ------------>
      <sino-pagination
        v-if="Object.keys(this.paginations).length > 0 && data.length > 0"
        :pagerCount="pagerCount"
        :paginations="paginations"
        :totalFlag="totalFlag"
        :page-layout="pageLayout"
        :is-page-text="isPageText"
        :show-current-page="showCurrentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></sino-pagination>
    </div>
  </div>
</template>

<script>
import btnList from "./btnList.vue";
import utils from "../../scripts/utils";
import sinoPagination from "./sinoPagination.vue";
import Sortable from "sortablejs";
// import Sortable from "sortablejs";
export default {
  name: "sino-table",
  components: {
    btnList,
    sinoPagination,
  },
  props: {
    stripe: {
      //是否显示斑马纹
      type: Boolean,
      default: false,
    },
    showTooltip: {
      //当内容过长被隐藏时显示 tooltip
      type: Boolean,
      default: true,
    },
    selection: {
      //是否为多选表格
      type: Boolean,
      default: false,
    },
    isTree: {
      //是否为树形结构
      type: Boolean,
      default: false,
    },
    tableExpand: {
      //是否开启展开行功能
      type: Boolean,
      default: false,
    },
    operateFixed: {
      //操作列是否固定，固定方向
      type: [String, Boolean],
      default: false,
    },
    hasOperation: {
      //操作列是否显示
      type: Boolean,
      default: true,
    },
    operateWidth: {
      //操作列宽度
      type: String,
      default: "140",
    },
    operateLabel: {
      type: String,
      default: "操作",
    },
    data: {
      //列表数据
      type: Array,
      default: () => {
        return [];
      },
    },
    columns: {
      //列表参数
      type: Array,
      default: () => {
        return [
          // {
          //   prop--对应列内容的字段名
          //   label--显示的标题
          //   align--对齐方式
          //   width--对应列的宽度
          //   slot--自定义列的内容
          //   isColumnSlot--是否自定义列
          //   type--type:time表示当前列为时间格式，时间可转换格式
          //   timeType--日期格式化方式
          //   dicList--1、传入字典列表名称，如statusList
          //          --2、传入字典key值，此时需同时传入dictData,dictData格式:dictData:{'sys_status':[]};sys_status为字典key
          // },
        ];
      },
    },
    btnList: {
      //操作列按钮数据
      type: Array,
      default: () => {
        return [];
      },
    },
    btnNum: {
      //按钮组超出固定个数后下拉显示
      type: Number,
      default: 3,
    },
    paginations: {
      //分页
      type: Object,
      default: () => {
        return {};
      },
    },
    totalFlag: {
      //分页器是否展示总数
      type: Boolean,
      default: true,
    },
    loading: {
      //表单加载
      type: Boolean,
      default: false,
    },
    lazy: {
      //树形表格是否懒加载
      type: Boolean,
      default: false,
    },
    treeProp: {
      //树形表格配置
      type: Object,
      default: () => {
        return {
          children: "children",
          hasChildren: "hasChildren",
        };
      },
    },
    pagerCount: {
      //分页器页码按钮的数量，当总页数超过该值时会折叠
      type: Number,
      default: 7,
    },
    emptyFlag: {
      //是否使用默认空数据
      type: Boolean,
      default: true,
    },
    maxHeight: {
      type: String,
      default: "—",
    },
    // 用于请求列表刷新时控制展开数据
    expandRowKeys: {
      type: Array,
      default: () => [],
    },
    tableRowClassName: {
      type: Function,
      default: () => "",
    },
    rowKey: {
      type: [Function, String],
      default: "uuid",
    },
    dictData: {
      //字典列表集合
      type: Object,
      default: () => {
        return null;
      },
    },
    isScroll: {
      type: [Boolean, Object],
      default: null,
    },
    tableClass: {
      //el-table父容器类名 与ly-c-table同级
      type: String,
      default: "",
    },
    pageLayout: {
      type: String,
      default: "prev, pager, next, sizes, jumper",
    },
    isPageText: {
      //控制分页器上一页、下一页按钮是否显示为文本
      type: Boolean,
      default: false,
    },
    showCurrentPage: {
      // 控制分页器，显示第几页
      type: Boolean,
      default: false,
    },
    showOrderNum: {
      //是否显示序号
      type: Boolean,
      default: true,
    },
    orderNumProp: {
      //序号列表参数
      type: Object,
      default: () => {
        return {
          label: "序号",
          prop: "orderNum",
          align: "left",
          width: "100",
        };
      },
    },
    canDrag: {
      //表格是否允许拖拽
      type: Boolean,
      default: false,
    },
    dragProps: {
      //表格拖拽时所需参数，表格拖拽时tableClass必传且唯一
      type: Object,
      default: () => {
        return {
          dragClass: "el-table__row",
        };
      },
    },
  },
  data() {
    return {
      tableColumns: [],
      tableData: [],
      newBtnList: this.btnList,
      noDataImg: require("../../assets/images/no_data.svg"),
      nullList: ["", "null", "undefined"],
      tableHeight: null,
    };
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler() {
        this.newBtnList = this.btnList;
        this.tableData = this.data;
        if (this.showOrderNum) {
          this.tableData.forEach((el, index) => {
            if (Object.keys(this.paginations).length > 0) {
              el[this.orderNumProp.prop] =
                (this.paginations.pageNum - 1) * this.paginations.pageSize +
                index +
                1;
            } else {
              el[this.orderNumProp.prop] = index + 1;
            }
          });
        }
      },
    },
    btnList: {
      deep: true,
      handler() {
        this.newBtnList = this.btnList;
      },
    },
    columns: {
      immediate: true,
      deep: true,
      handler() {
        if (this.showOrderNum) {
          let data = [this.orderNumProp];
          let flag = !this.isTree && !this.tableExpand && !this.lazy;
          if (this.columns.length <= 4 && flag) {
            let hasOrderNum = false;
            this.columns.forEach((el) => {
              if (el.label == this.orderNumProp.label) {
                hasOrderNum = true;
              }
            });
            if (!hasOrderNum) {
              this.tableColumns = [...data, ...this.columns];
            } else {
              this.tableColumns = this.columns;
            }
          } else {
            this.tableColumns = this.columns;
          }
        } else {
          this.tableColumns = this.columns;
        }
      },
    },
  },
  mounted() {
    if (this.canDrag) {
      this.$nextTick(() => {
        this.drag();
      });
    }
  },
  methods: {
    headerRowClassName() {
      return "custom-header";
    },
    showStatus(item, scope) {
      if (item.isShow != undefined) {
        return item.isShow(scope, item);
      } else {
        return true;
      }
    },
    // 首次计算由于部分数据未请求完导致页面高度计算偏差，改成直接方法返回
    getHeight() {
      this.$nextTick(() => {
        let tableContainer = document.querySelector(".table-container");
        let flag =
          (this.isTableScroll && this.isScroll === null) || this.isScroll;
        let otherNum = Object.keys(this.paginations).length > 0 ? 58 : 2;
        if (flag && tableContainer) {
          this.tableHeight = tableContainer.clientHeight - otherNum;
        }
        return (this.maxHeight && this.maxHeight != "—") || this.tableHeight;
      });
      //isTableScroll 全局变量
    },
    getDicName(value, list) {
      let new_list = [];
      if (this.dictData) {
        new_list = this.dictData[list] || [];
      } else {
        new_list = this.$parent[list]
          ? this.$parent[list]
          : this.$parent.$parent[list];
      }
      return utils.getDicName(value, new_list);
    },
    getNull(val) {
      return this.nullList.includes(val);
    },
    tableNull(row, item) {
      return !item.slot && !this.getNull(row[item.prop]);
    },
    load(tree, treeNode, resolve) {
      this.$emit("lazyLoad", tree, treeNode, resolve);
    },
    rowClick(row, column, event) {
      this.$emit("row-click", row, column, event);
    },
    cellClick(row, column, cell, event) {
      this.$emit("cell-click", row, column, cell, event);
    },
    cellMouseEnter(row, column, cell, event) {
      this.$emit("cell-mouse-enter", row, column, cell, event);
    },
    cellMouseLeave(row, column, cell, event) {
      this.$emit("cell-mouse-leave", row, column, cell, event);
    },
    /**
     * 判断日期是否格式化
     * @param date 日期
     * @param timeType 日期格式化方式,如 yyyy-MM-dd
     */
    dateFormat(date, timeType) {
      let datePattern1 =
        /^[1-2][0-9][0-9][0-9]-[0-1]{0,1}[0-9]-[0-3]{0,1}[0-9]$/;
      let datePattern2 =
        /^[1-2][0-9][0-9][0-9][/][0-1]{0,1}[0-9][/][0-3]{0,1}[0-9]$/;
      if (!date) return "";
      //判断date是否是日期
      if (isNaN(date) && !isNaN(Date.parse(date))) {
        //正则判断日期是否需要转换
        if (datePattern1.test(date) || datePattern2.test(date)) {
          return date;
        } else {
          let fmt = timeType ? timeType : "yyyy-MM-dd";
          return utils.formatDatetime(date, fmt);
        }
      } else {
        return date;
      }
    },
    doLayout() {
      this.$refs.tableRef.doLayout();
    },
    // 调用表格复选框勾选事件，传入选中列表格对象
    toggleRowSelection(val, selected) {
      this.$refs.tableRef.toggleRowSelection(val, selected);
    },
    clearSelection() {
      this.$refs.tableRef.clearSelection();
    },
    handleSelect(val) {
      this.$emit("select", val);
    },
    // 多选表格全选checkbox点击事件
    handleSelectAll(val) {
      this.$emit("select-all", val);
    },
    handleSizeChange(val) {
      this.$emit("size-change", val);
    },
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },
    handleSelectionChange(val) {
      this.$emit("selection-change", val);
    },
    handleExpandChange(row, expandRows) {
      this.$emit("expand-change", row, expandRows);
    },
    /**状态启用/停用 */
    switchChange(row, params = {}, item) {
      if (item.type == "status") {
        this.$emit("status-change", row, params);
      } else {
        let funName = item.prop + "-change";
        this.$emit(funName, row, params);
      }
    },
    /**表格拖拽排序 */
    drag() {
      let tableClass = "." + this.tableClass;
      const el = document.querySelector(
        tableClass + " .el-table__body-wrapper > table > tbody"
      );
      Sortable.create(el, {
        disabled: false, // boolean 定义是否此sortable对象是否可用，为true时sortable对象不能拖放排序等功能，为false时为可以进行排序，相当于一个开关；
        handle: "." + this.dragProps.dragClass, // 格式为简单css选择器的字符串，使列表单元中符合选择器的元素成为拖动的手柄，只有按住拖动手柄才能使列表单元进行拖动
        animation: 150, // 拖拽延时
        onEnd: (e) => {
          // 拖拽结束时的触发
          const arr = this.data; // 获取表数据
          let btnList = JSON.parse(JSON.stringify(this.newBtnList));
          arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
          //处理按钮组数据
          btnList.splice(e.newIndex, 0, btnList.splice(e.oldIndex, 1)[0]);
          this.data = arr;
          this.newBtnList = btnList;
          this.$emit("dragEnd", this.data);
        },
      });
    },
  },
};
</script>

<style>
.ly-c-table thead tr,
.ly-c-table .custom-header {
  th {
    background-color: #e2eaf4 !important;
    &:first-child {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }
    &:last-child {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }
}
.ly-c-table .el-table th.el-table__cell {
  font-weight: 500;
  color: #02111d !important;
}
.ly-c-table .el-table {
  tr {
    &:nth-child(2n) {
      td {
        background-color: #f4f6fa !important;
        &:first-child {
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
        }
        &:last-child {
          border-top-right-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "../../assets/styles/primary.module.scss";
.table-container {
  flex-grow: 1;
  height: 0;
  overflow: hidden;
  .ly-c-table {
    height: 100%;
  }

  &.transparent {
  }
}
/deep/ .status-switch {
  position: relative;
  &.is-checked {
    .el-switch__core {
      background: $switch_background;
      border: 1px solid $switch_border;
      &::after {
        left: calc(100% - 15px);
        margin-left: 0;
        background-color: $primaryColor;
      }
    }
    .el-switch__label {
      left: 0;
      color: $primaryColor;
    }
  }

  .el-switch__core {
    height: 18px;
    width: 43px !important;
    border-radius: 9px;
    background: rgba(194, 74, 74, 0.18);
    border: 1px solid rgba(194, 74, 74, 0.2);
    &:after {
      width: 12px;
      height: 12px;
      top: 50%;
      transform: translateY(-50%);
      // right: 2px;
      left: 3px;
      background-color: #c24a4a;
    }
  }
  .el-switch__label {
    font-weight: 500;
    font-size: 12px;
    // font-size: 9px;
    -webkit-transform: scale(0.75);
    position: absolute;
    margin-left: 0;
    right: 1px;
    color: #c24a4a;
  }
  // &:not(.more) {
  //   &:not(.is-checked) {
  //     .el-switch__core {
  //       background: rgba(194, 74, 74, 0.18);
  //       border: 1px solid rgba(194, 74, 74, 0.2);
  //       &:after {
  //         background-color: #c24a4a;
  //       }
  //     }
  //   }
  // }
  &.more {
    &:not(.is-checked) {
      &.no-status {
        .el-switch__core {
          width: 54px !important;
          background: rgba(158, 176, 194, 0.14);
          border: 1px solid rgba(158, 176, 194, 0.12);
          &:after {
            background-color: #9eb0c2;
          }
        }
        .el-switch__label {
          right: 0px;
          color: #8da3b9;
        }
      }
    }
  }
}
</style>
